module.exports = __webpack_public_path__ + "static/img/image_solutions_servo_02.47a9c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_servo_02.png
// module id = FNCv
// module chunks = 10